export default "__VITE_ASSET__wV$oljcA__"